import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { parseJWT } from '@/lib/helpers/common.helper';
import { IUser } from './lib/interfaces';
import { getAllUsers } from './services/api.service';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState({
    // filter: (mutation) => mutation.type === 'toggleSprintTab',
    paths: ['hiddenSprintTabs', 'hiddenProjectTabs'],
  })],
  state: {
    navBar: false,
    currentUser: parseJWT(),
    hiddenSprintTabs: {},
    hiddenProjectTabs: {},
    users: {},
  },
  mutations: {
    toogleNavBar(state) {
      state.navBar = !state.navBar;
    },
    toggleSprintTab(state, sprintId: string) {
      if (state.hiddenSprintTabs[sprintId]) {
        Vue.delete(state.hiddenSprintTabs, sprintId);
      } else {
        Vue.set(state.hiddenSprintTabs, sprintId, true);
      }
    },
    toggleProjectTab(state, projectId: string) {
      if (state.hiddenProjectTabs[projectId]) {
        Vue.delete(state.hiddenProjectTabs, projectId);
      } else {
        Vue.set(state.hiddenProjectTabs, projectId, true);
      }
    },
    setUsers(state, users: IUser[]) {
      users.forEach((user) => {
        // state.users.set(user._id, user);
        Vue.set(state.users, user._id, user);
      });
    },
  },
  actions: {
    fetchUsers(store) {
      return getAllUsers()
        .then((users) => {
          store.commit('setUsers', users);
        });
    },
  },
  getters: {
    isNavBarActive(state) {
      return state.navBar;
    },
    getCurrentUser(state) {
      return state.currentUser;
    },
  },
});
